import { render, staticRenderFns } from "./AdministrationMediaTypeManage.vue?vue&type=template&id=a71ccd46&scoped=true"
import script from "./AdministrationMediaTypeManage.vue?vue&type=script&lang=js"
export * from "./AdministrationMediaTypeManage.vue?vue&type=script&lang=js"
import style0 from "./AdministrationMediaTypeManage.vue?vue&type=style&index=0&id=a71ccd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71ccd46",
  null
  
)

export default component.exports